<template>
  <card-collapsable
    :headerClass="headerClass"
    dialogClass="bustachiusa"
    :dialogProp="dialog"
    @changeCollapse="changeCollapse"
  >
    <!-- :collapsed="collapsed" -->
    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-if="asta_settings.timeout_s && calciatoreInAsta && !offerto && active"
        ref="timer_bustachiusa"
        :time="asta_settings.timeout_s"
        @timeStep="setBustaChiusaTimeLeft"
        @timeover="timeoverBustaChiusa"
        name="bustachiusa"
      ></progress-countdown>
      <v-icon v-if="collapsed && passato">airline_stops</v-icon>
      <squadra-offerta
        v-else-if="collapsed && offerto"
        :offerta="miaOfferta"
        :label="''"
        :uid="user_uid"
        creditiGlow
      ></squadra-offerta>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        offerteCompletate
          ? "Tutti hanno inviato la busta"
          : !active && admin
          ? "Attendi tutte le offerte"
          : "Fai offerta"
      }}
    </template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto
        :id="calciatoreInAsta"
        v-if="calciatoreInAsta"
        xLarge
      ></calciatore-battuto>

      <!-- 1) Buste da aprire/aperte -->
      <div v-if="roundStep && roundStep.type == Constants.ROUND_STEP.BUSTE">
        <div v-if="bustaChiusaProcessing" class="pa-4 text-center">
          <v-progress-circular
            indeterminate
            :size="18"
            :width="2"
          ></v-progress-circular>
          <div class="text-body-2 mt-2">Assegnazione in corso...</div>
        </div>
        <template v-else>
          <v-list class="lista_buste">
            <!-- lista offerte -->
            <v-list-item v-for="off in bustaChiusaOfferteOrdinate" :key="off.s">
              <v-list-item-avatar>
                <img :src="squadra(off.s).pic" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="off.squadraName"
                ></v-list-item-title>
                <div v-if="off.o > Constants.OFFERTA.PASSO">
                  <v-icon color="text" x-small>schedule</v-icon>
                  <small><span v-html="bustaChiusaOffertaTime(off.s)"></span></small>
                </div>
                <div v-else>
                  <small>Nessuna offerta</small>
                </div>
              </v-list-item-content>

              <v-list-item-action>
                  <crediti v-if="
                    off.o == migliore_offerta.offerta &&
                    off.o !== Constants.OFFERTA.PASSO
                  " class="offerta" :crediti="off.o" variant="dark"></crediti>
                <span v-else-if="off.o == Constants.OFFERTA.PASSO"></span>
                <crediti class="offerta" v-else :crediti="off.o" ></crediti>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <!-- Esito buste -->
          <div class="text-center" v-if="offerteCompletate">
            <v-divider></v-divider>
            <div class="ma-4 text-body-1">
              <span v-html="esito_buste"></span>
            </div>
            <v-btn
              depressed
              class="mb-4"
              color="primary"
              rounded
              v-if="admin"
              :loading="loading"
              @click="esito"
              >Avanti</v-btn
            >
          </div>
        </template>
      </div>

      <!-- Durante Collezione Offerte -->
      <div v-else class="text-center">
        <div v-if="active">
          <!-- 1a) Collezione Offerte (io): se non ho offerto o passato -->
          <div
            v-if="!offerto && !passato"
            class="ma-4"
          >
            <div class="d-flex justify-center align-center">
              <v-btn
                depressed
                color="primary"
                rounded
                id="numpad-btn"
                @click="showNumpad"
              >
                Offerta
              </v-btn>
              <v-btn
                color="primary"
                text
                rounded
                v-if="roundStep && !roundStep.min_offerta"
                @click="setPasso(true)"
              >
                Passo
              </v-btn>
            </div>
            <v-alert
              v-if="showBustaChiusaAutoConfirmHint"
              dense
              text
              type="info"
              class="mt-3 mb-0 text-left"
            >
              {{ bustaChiusaAutoConfirmHint }}
            </v-alert>
          </div>

          <!-- 1b) Collezione Offerte (io): nn posso offrire -->
          <div v-else-if="bustaChiusaCannotJoinReason" class="ma-4">
            <v-chip outlined color="error">
              {{ bustaChiusaCannotJoinReason }}
            </v-chip>
          </div>

          <!-- 1c) Collezione Offerte (io): se ho passato -->
          <div v-else-if="passato" class="ma-4">
            <div class="error--text text-button">
              <v-icon left class="error--text">airline_stops</v-icon>
              {{ bustaChiusaPassoText }}
            </div>
          </div>

          <!-- 1d) Collezione Offerte (io): se ho offerto -->
          <div v-else-if="offerto">
            <squadra-offerta
              :offerta="miaOfferta"
              :label="'La mia offerta'"
              :uid="user_uid"
              variant="horizontal"
              creditiGlow
            ></squadra-offerta>
          </div>
        </div>

        <!-- 2a) Collezione Offerte (tutti): se Tutti hanno inviato la busta -->
        <div v-if="offerteCompletate" class="ma-4">
          <v-btn color="primary" rounded large v-if="admin" @click="apriBuste"
            >Apri buste</v-btn
          >
          <div v-else>
            <div class="text-body-2">
              <v-progress-circular
                indeterminate
                :size="15"
                :width="2"
              ></v-progress-circular>
              In attesa che l'admin apra le buste...
            </div>
          </div>
        </div>

        <!-- 2b) Collezione Offerte (tutti): Se io ho offerto ma qualcun altro no -->
        <div
          v-else-if="(offerto && !offerteCompletate) || (admin && !active)"
          class="pa-2"
        >
          <div class="text-body-2">
            <v-progress-circular
              indeterminate
              :size="15"
              :width="2"
            ></v-progress-circular>
            In attesa degli altri partecipanti...
          </div>
        </div>
      </div>
    </template>

    <!-- footer -->
    <template #actions>
      <div v-if="squadra(user_uid) && !offerto && active" class="pa-4">
        <squadra-info-panel :id_squadra="user_uid"></squadra-info-panel>
      </div>
      <div v-if="my_squadra" class="px-4 pb-4">
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller navy darken-2 pb-2 rounded"
        >
          <div class="text-center py-2">Pianificazione ruolo</div>
          <asta-consiglio></asta-consiglio>
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
          ></asta-slot>
        </v-list>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import astaBustaChiusaActionsMixin from "../../js/mixins/astaBustaChiusaActionsMixin";
import * as types from "../../store/mutations-types";

import toast from "../../js/toast";
import ProgressCountdown from "../common/ProgressCountdown";
import SquadraInfoPanel from "../common/SquadraInfoPanel";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import CardCollapsable from "../common/CardCollapsable";
import SquadraOfferta from "../common/SquadraOfferta";
import AstaSlot from "../AstaSlot";
import AstaConsiglio from "../AstaConsiglio";
import Crediti from "../common/Crediti";

export default {
  name: "asta-busta-chiusa",
  mixins: [mixins, toast, astaBustaChiusaActionsMixin],
  components: {
    ProgressCountdown,
    SquadraInfoPanel,
    CalciatoreBattuto,
    CardCollapsable,
    SquadraOfferta,
    AstaSlot,
    AstaConsiglio,
    Crediti
  },
  data() {
    return {
      resetT: false,
      timeover: true,
      step: 1,
      esito_buste: "",
      esito_cb: () => {},
      collapsed: false,
      loading: false,
    };
  },
  mounted() {
    console.log("--> AstaBustaChiusa ready.");
    // Start / Stop timer in funzione dello stato dell'asta
    db.on("status", this.onStatusChange);
    db.on("numpadSubmitted", this.inviaBusta);
  },
  destroyed() {
    console.log("<-- AstaBustaChiusa destroyed.");
    db.off("status", this.onStatusChange);
    db.off("numpadSubmitted", this.inviaBusta);
  },
  methods: {
    async esito() {
      this.loading = true;
      await this.wait(1000); // altrimenti il loader nn si vede
      await this.esito_cb();
      this.loading = false;
    },
    onStatusChange(status) {
      //if (this.mode_bustachiusa && this.calciatoreInAsta !== null) {
      // if (this.is_calciatore_in_asta) {
      switch (status) {
        case Constants.ASTA_STATUS.NOT_RUNNING:
          this.stopTimer();
          break;
        case Constants.ASTA_STATUS.RUNNING:
          if (
            this.roundStep &&
            this.roundStep.type === Constants.ROUND_STEP.OFFERTE
          ) {
            this.startTimer();
          } else if (
            this.roundStep &&
            this.roundStep.type === Constants.ROUND_STEP.BUSTE
          ) {
            this.esaminaBuste();
          }
          break;
      }
      // }
    },
    changeCollapse(val) {
      this.collapsed = val;
    },

    esaminaBuste() {
      const esito = this.getBustaChiusaEsito();
      this.esito_buste = esito.text;
      this.esito_cb = esito.cb;
    },
    stopBustaTimer() {
      this.stopTimer();
    },
    setBustaChiusaTimeLeft(timeLeft) {
      this.$store.commit(types.ASTA_LOCAL_TIMERS_UPD, {
        bustaChiusaTimeLeft: parseInt(timeLeft),
      });
    },
    resetBustaChiusaTimeLeft() {
      this.$store.commit(types.ASTA_LOCAL_TIMERS_UPD, {
        bustaChiusaTimeLeft: null,
      });
    },
    timeoverBustaChiusa() {
      this.timeover = true;
      setTimeout(() => {
        if (
          !this.offerto &&
          this.running &&
          this.squadra(this.user_uid).active
        ) {
          if (this.roundStep.min_offerta) {
            db.setOfferta(this.roundStep.min_offerta, false, true);
          } else {
            this.setPasso();
          }
        }
      }, 2000);
    },
    startTimer() {
      this.timeover = false;
      this.$nextTick(() => {
        if (this.$refs["timer_bustachiusa"] !== undefined) {
          this.$refs["timer_bustachiusa"].start();
        }
      });

      // NECESSARIO PER RITARDARE L'ASSEGNAZIONE DI resetT
      setTimeout(() => {
        this.resetT = true;
      }, 0);
    },
    stopTimer() {
      if (this.$refs["timer_bustachiusa"] !== undefined) {
        this.$refs["timer_bustachiusa"].stop();
      } else {
        // console.log("timer_bustachiusa non è definito");
      }
      this.resetBustaChiusaTimeLeft();
    },
  },
  watch: {
    roundStep(val) {
      if (this.running) {
        if (val !== null && val.type === Constants.ROUND_STEP.OFFERTE) {
          this.startTimer();
        } else if (val !== null && val.type === Constants.ROUND_STEP.BUSTE) {
          this.stopTimer();
          this.esaminaBuste();
        }
      }
    },
    timeover(val) {
      if (val) {
        this.hideNumpad();
      }
    },
    dialog(val) {
      if (!val) {
        this.hideNumpad();
      } else {
        this.loading = false;
      }
    },
  },
  computed: {
    headerClass() {
      return {
        "yellow darken-2 white--text": !this.offerteCompletate,
        "text white--text": this.offerteCompletate,
      };
    },
    // collapsed() {
    //   return false;
    // },
    vincitore() {
      return this.migliore_offerta.vincitore;
    },
    sonoVincitore() {
      return this.miaOfferta === this.migliore_offerta.offerta;
    },
    miaOffertaTime() {
      return this.offertaTime(this.user_uid);
    },
    dialog() {
      return Boolean(
        (this.active || this.admin) &&
          this.calciatoreInAsta !== null &&
          this.calciatoreInAsta !== undefined &&
          this.running
      );
    },
  },
};
</script>
<style>
.lista_buste {
  max-height: 205px;
  overflow: auto;
}
.millis {
  color: var(--v-navy-lighten4)
}
</style>
